import React from 'react';
import SmartImage from '../../subcomponents/SmartImage';
import Cta from '../../subcomponents/Cta';
import findAltText from '../../utils';

import './story.scss';

const ThreeSixty = React.lazy(() => import('../360/ThreeSixty'));

const Story = ({
  element, url, isBootroom, version, campaignType, order,
}) => {
  const {
 cta, 
 position, 
 threeSixty, 
 centerText, 
 hideCta, 
 titleColor, 
 mobileTitleColor,
 storyNumber, 
 type, 
 textColor, 
 mobileTextColor, 
 useMobileText,
 noBackground, 
 backgroundColor, 
 useGradient, 
 backgroundGradient, 
 gradientDirection,
 hide, 
 navStory, 
 textAnimation = '', 
 CTAAnimation = '',
 anchorName, 
 content, 
 roundedCorners, 
 removeArrow,
} = element;
  const { slug, imagePattern } = url;
  const translations = window.campaign_data.campaign_translations.blocks;
  const commonTranslations = window.campaign_data.common_translations.blocks;
  const uppercaseLetters = url.generalData ?
  url.generalData.uppercaseLetters
  : false;

  let displayTextColor = textColor;
  let displayTitleColor = titleColor;
  if (useMobileText && window.innerWidth < 768) displayTextColor = mobileTextColor;
  if (useMobileText && window.innerWidth < 768) displayTitleColor = mobileTitleColor;
  const roundTheCorners = (campaignType === 'general' && roundedCorners) ? 'rounded-corners' : '';
  const titleTranslation = campaignType === 'general' ? translations[`${content}title`] : translations.storytellingtitle;

  const classes = uppercaseLetters ? 'story-title title title--uppercase' : 'story-title title';
  let styler = {};
     if (noBackground && useGradient && gradientDirection === 'leftToRight') {
       styler = { background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && useGradient && gradientDirection === 'topToBottom') {
       styler = { background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && !useGradient) {
       styler = { background: backgroundColor };
    } else {
       styler = {};
        }
  let component = null;
  if (!hide) {
    component = (
      <section
        id={anchorName || ''}
        className={`${noBackground ? 'component story-section smart-section' : 'component story-section'} ${navStory ? 'nav-story' : ''}`}
        style={styler}
        dataorder={order}
        datatype={type}
      >
        {!noBackground &&
          <SmartImage
            className={`${navStory && campaignType !== 'general' ? 'nav-story' : ''} ${campaignType === 'general' ? 'heightBackground' : ''}`}
            slug={slug}
            name={campaignType !== 'general' ? `020-story${imagePattern}` : `020-story${storyNumber}${imagePattern}`}
            version={version}
            campaignType={campaignType}
            alt={findAltText(`Story Background ${storyNumber}`, titleTranslation)}
          />
        }
        <div className="mainWidth">
          {threeSixty.is360Present &&
            <React.Suspense fallback={null}>
              <ThreeSixty
                name={`020-360${campaignType === 'general' ? (`-${storyNumber}`) : ''}-overlay${imagePattern.split('.')[0]}.png`}
                images={Number(threeSixty.numberOfImages)}
                reverseRotation={threeSixty.reverseRotation}
                loaderColor={threeSixty.loaderColor}
                slug={slug}
                position={position}
                version={version}
                componentNumber={storyNumber}
                campaignType={campaignType}
                findAltText={findAltText}
                titleTranslation={titleTranslation}
              />
            </React.Suspense>
          }
          <div className={`story-textholder ${position} ${navStory ? 'nav-story' : ''} ${centerText ? 'center-text' : ''}`}>
            <h1 className={classes} style={{ color: displayTitleColor }}>
            {titleTranslation}
            </h1>
            <p data-animation-type={textAnimation} className="story-text text" style={{ color: displayTextColor }}>
            {campaignType === 'general' ? translations[`${content}text`] : translations.storytellingtext}
            </p>
            {!isBootroom && !hideCta &&
              <div data-animation-type={CTAAnimation}>
                <Cta
                  className={roundTheCorners}
                  url={campaignType !== 'general' ? translations.linkcategory : translations[`story${storyNumber}link`]}
                  translation={commonTranslations.shopnow}
                  backgroundColor={cta.ctaBackgroundColor}
                  textColor={cta.ctaTextColor}
                  ctaArrowColor={cta.ctaArrowColor}
                  borderColor={cta.ctaBorderColor}
                  noArrow={removeArrow}
                  campaignType={campaignType}
                />
              </div>
            }
          </div>
        </div>
      </section>
    );
  }

  return (
    <React.Fragment>
      { component }
    </React.Fragment>
  );
};

export default Story;
